
// SVG Icon: remotefile
export default { id: "terriajs-remotefile" };
export const id = "terriajs-remotefile";
export const name = "remotefile";
